/**
 * "Message a colleague" (staff chat MVP, SR-14) for the patient chart header and the encounter header. Opens the Team
 * dock on New message for this patient; picking a colleague finds or creates the patient thread
 * (POST threads { participantUserId, patientId }). Only the patient's id is sent: nothing from the chart or the note goes
 * into the thread.
 *
 * Patient threads wait for Samer's call (patient-data access and audit): renders nothing unless BOTH `?x=staff-chat` and
 * `?x=staff-chat-patient` are on, or without a patient id.
 */
import { Button } from '@scripsteam/scrips-signal-ds';
import { MessageSquare } from 'lucide-react';
import { isStaffChatPatientOn } from '@/staff-chat/lib/staff-chat-switch';
import { useDockStore } from '@/staff-chat/lib/dock-store';

export function MessageColleagueAction({ patientId }: { patientId: string | null | undefined }) {
  if (!isStaffChatPatientOn() || !patientId) return null;
  return <MessageColleagueButton patientId={patientId} />;
}

function MessageColleagueButton({ patientId }: { patientId: string }) {
  const startNewMessage = useDockStore((s) => s.startNewMessage);
  return (
    <Button
      type="button"
      variant="secondary"
      size="sm"
      data-slot="message-colleague"
      icon={<MessageSquare aria-hidden />}
      onClick={() => startNewMessage({ patientId })}
    >
      Message a colleague
    </Button>
  );
}
